import { render } from "./App.vue?vue&type=template&id=7c4eb8cd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c4eb8cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c4eb8cd', __exports__)) {
    console.log('reload')
    api.reload('7c4eb8cd', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=7c4eb8cd", () => {
    console.log('re-render')
    api.rerender('7c4eb8cd', render)
  })

}


export default __exports__